import { Form, Popover, Tooltip } from "antd";
import "../../../src/main.css";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate, formatDoctorDate } from "modules/utilities/utility";
import { Select } from "antd";
import FilterIcon from "assets/svgs/filter_icon";
import { CloseOutlined } from "@ant-design/icons";

function DoctorInputFilter(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNumber");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState(null);
  const [stage, setStage] = useState(searchParams.get("stage"));
  const [constipation, setConstipation] = useState(
    searchParams.get("constipation")
  );
  const [sleep, setSleep] = useState(searchParams.get("sleep"));
  const [deficiency, setDeficiency] = useState(searchParams.get("deficiency"));
  const [form] = Form.useForm();
  const start = searchParams.get("StartDate");
  const end = searchParams.get("endDate");
  const [visible, setVisible] = useState(false);

  const handleClosePopover = () => {
    setVisible(!visible);
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    setStartDate("");
  };
  const handleResetEndDate = () => {
    setEndDate("");
  };
  const handleFilterSubmit = () => {
    let queryParams = "";
    let urlData = "";
    const formattedStartDate = startDate ? formatDoctorDate(startDate) : null;
    const formattedEndDate = endDate ? formatDoctorDate(endDate) : null;
    if (startDate && endDate) {
      queryParams += `StartDate=${formattedStartDate}&endDate=${formattedEndDate}`;
    }
    if (stage) {
      queryParams += `&stage=${stage}`;
    }
    if (constipation) {
      queryParams += `&constipation=${constipation}`;
    }
    if (sleep) {
      queryParams += `&sleep=${sleep}`;
    }
    if (deficiency) {
      queryParams += `&deficiency=${deficiency}`;
    }

    if (queryParams[0] === "&") {
      urlData = queryParams.replace(/&/, "");
      navigate(`/home?${urlData}`);
      props.setQueryParams(urlData);
    } else {
      navigate(`/home?${queryParams}`);
      props.setQueryParams(queryParams);
    }
    props.newPage(1);
  };

  const stageOptions = [
    { label: "Stage", value: "" },
    { label: "Stage-1", value: "Stage-1" },
    { label: "Stage-2", value: "Stage-2" },
    { label: "Stage-3", value: "Stage-3" },
    { label: "Stage-4", value: "Stage-4" },
    { label: "Stage-5", value: "Stage-5" },
    { label: "Stage-6", value: "Stage-6" },
    { label: "Coin Size Patch", value: "Coin Size Patch" },
    {
      label: "Heavy Hair Fall Across The Head",
      value: "Heavy Hair Fall Across The Head",
    },
  ];
  const sleepOptions = [
    { label: "Sleep", value: "" },
    {
      label: "Very peacefully for 6 to 8 hours",
      value: "Very peacefully for 6 to 8 hours",
    },
    {
      label: "Disturbed sleep, I wake up at least one time during the night",
      value: "Disturbed sleep, I wake up at least one time during the night",
    },
    {
      label: "Have difficulty falling asleep",
      value: "Have difficulty falling asleep",
    },
  ];

  const deficiencyOptions = [
    { label: "Deficiency", value: "" },
    { label: "No", value: "No" },
    { label: "Yes", value: "Yes" },
    { label: "Not Sure", value: "Not Sure" },
  ];

  const constipationOptions = [
    { label: "Constipation", value: "" },
    {
      label: "No/Rarely",
      value: "No/Rarely",
    },
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "Unsatisfactory bowel movements",
      value: "Unsatisfactory bowel movements",
    },
    {
      label: "Suffering from IBS (irritable bowel syndrome) /dysentery",
      value: "Suffering from IBS (irritable bowel syndrome) /dysentery",
    },
  ];

  const handleClear = () => {
    form.resetFields();
    setStartDate("");
    setEndDate("");
    setStage("");
    setConstipation("");
    setSleep("");
    setDeficiency("");
    props.setQueryParams("");
    navigate(`/home?pageNo=1`);
    props.newPage(1);
  };

  let formInitialValues = {
    stage: stage,
    constipation: constipation,
    sleep: sleep,
    deficiency: deficiency,
  };

  const content = (
    <div
      className="popover-content"
      style={{ width: "18rem", height: "25rem" }}
    >
      <div className="mt-n2 d-flex flex-column gap-2">
        <Form
          className="order-filter float-end d-flex flex-column gap-2"
          form={form}
          initialValues={formInitialValues}
          layout="inline"
          onFinish={handleFilterSubmit}
        >
          <Form.Item>
            <div className="input-container-summary">
              {startDate ? (
                ""
              ) : (
                <div className="calendar-icon-container-summary">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                placeholderText="Start Date"
                dateFormat="dd-MM-yyyy"
                value={
                  startDate
                    ? formatDate(startDate)
                    : start
                    ? start.slice(0, 10)
                    : ""
                }
                className="input-with-icon"
              />
              {startDate && (
                <span className="reset-icon" onClick={handleResetStartDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Item>
          <Form.Item>
            <div className="input-container-summary">
              {endDate ? (
                ""
              ) : (
                <div className="calendar-icon-container-summary">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                placeholderText="End Date"
                dateFormat="dd-MM-yyyy"
                value={
                  endDate ? formatDate(endDate) : end ? end.slice(0, 10) : ""
                }
              />
              {endDate && (
                <span className="reset-icon" onClick={handleResetEndDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Item>
          <Form.Item name="stage">
            <Select
              allowClear
              dropdownStyle={{ minWidth: "15rem" }}
              style={{ width: "16rem" }}
              id="is_finished_input"
              options={stageOptions}
              onChange={(e) => (e ? setStage(e) : setStage(null))}
              placeholder="Stage"
            />
          </Form.Item>
          <Form.Item name="constipation">
            <Select
              allowClear
              options={constipationOptions}
              style={{ width: "16rem" }}
              onChange={(e) =>
                e ? setConstipation(e) : setConstipation(undefined)
              }
              placeholder="Constipation"
            />
          </Form.Item>
          <Form.Item name="sleep">
            <Select
              allowClear
              options={sleepOptions}
              onChange={(e) => (e ? setSleep(e) : setSleep(undefined))}
              placeholder="Sleep"
              style={{ width: "16rem" }}
            />
          </Form.Item>
          <Form.Item name="deficiency">
            <Select
              allowClear
              options={deficiencyOptions}
              onChange={(e) =>
                e ? setDeficiency(e) : setDeficiency(undefined)
              }
              placeholder="Deficiency"
              style={{ width: "16rem" }}
            />
          </Form.Item>
          <div
            className="d-flex flex-row mt-3 justify-content-between"
            style={{ width: "16rem" }}
          >
            <Button variant="primary mt-1" className="primary" type="submit">
              Submit
            </Button>
            <Button variant="primary" className="mt-1" onClick={handleClear}>
              Clear
            </Button>
          </div>
          <div>
          <Tooltip placement="top" title="Close Filter">
              <div
                onClick={() => {
                  setVisible(!visible);
                }}
                className="float-end me-4 border rounded-circle cursor-pointer px-2 pb-1"
              >
                <CloseOutlined />
              </div>
            </Tooltip>
          </div>
        </Form>
      </div>
    </div>
  );

  return (
    <>
      {
        <Popover
          content={content}
          title="Filter for Assigned Order"
          trigger="click"
          visible={visible}
          placement="leftTop"
          overlayClassName="popover-border"
        >
          <div
            className="fs-3 text-white cursor-pointer"
            onClick={handleClosePopover}
          >
            <Tooltip placement="top" title="Filter">
              <Button
                type="primary"
                className=" border fs-2 text-white mb-n2 cursor-pointer"
                onClick={() => setVisible(!visible)}
                style={{ height: "2.4rem" }}
              >
                <FilterIcon />
              </Button>
            </Tooltip>
          </div>
        </Popover>
      }
    </>
  );
}
export default DoctorInputFilter;
